import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://epreicqrqnvpnmcxpjla.supabase.co";
// const supabaseKey = process.env.SUPABASE_KEY;
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVwcmVpY3FycW52cG5tY3hwamxhIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY5ODg2OTc4NSwiZXhwIjoyMDE0NDQ1Nzg1fQ.vGfb8HbjNDpjFOc-46O1lVX5cvGfSQ70_NadBLUz7Ps";
  // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVwcmVpY3FycW52cG5tY3hwamxhIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTg4Njk3ODUsImV4cCI6MjAxNDQ0NTc4NX0.fp2kMS85dfchK629siW4pWELrV7lHVMO2ylQo4xykCM";

export const supabase = createClient(supabaseUrl, supabaseKey);
